/** @format */

import {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';

import {ModalSimple} from 'components/ModalSimple';

import {FormState} from './components/FormState';
import {SuccessState} from './components/SuccessState';
import {ContentWrapper} from './styles';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const AnalyticsSystemModal = ({isOpen, onClose}: Props) => {
  const {t} = useTranslation();
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setIsSuccess(false);
    }
  }, [isOpen]);

  const handleSuccess = () => {
    setIsSuccess(true);
  };

  const handleClose = () => {
    setIsSuccess(false);
    onClose();
  };

  return (
    <ModalSimple
      isOpen={isOpen}
      onClose={handleClose}
      headerText={t('Сообщить о своей системе аналитики', 'Сообщить о своей системе аналитики')}
    >
      <ContentWrapper>
        {isSuccess ? (
          <SuccessState onClose={handleClose} />
        ) : (
          <FormState onSuccess={handleSuccess} />
        )}
      </ContentWrapper>
    </ModalSimple>
  );
};

export {AnalyticsSystemModal};
